import { render, staticRenderFns } from "./MoleculeEditionAssetSignedStudentsContents.vue?vue&type=template&id=c8add022&scoped=true&"
import script from "./MoleculeEditionAssetSignedStudentsContents.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAssetSignedStudentsContents.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeEditionAssetSignedStudentsContents.vue?vue&type=style&index=0&id=c8add022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8add022",
  null
  
)

export default component.exports